var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',{attrs:{"value":_vm.progress,"max":100,"height":"5px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }